import type { IAdSpendChannelsFilterDto } from "../../../types/leadsSearchFilters.dto";

export const CHANNELS_KEYS: (keyof IAdSpendChannelsFilterDto)[] = ["searchChannelShare", "displayChannelShare"];
